import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { UserManagementService } from '../../services/user-management.service';
import { RequestUtil } from '../../utils/request.util';
import { ActionTypes, GetCountriesAndLanguages } from '../actions/user-management.action';
import { UserManagementState } from '../state/user-management.state';

@Injectable()
export class UserManagementEffects {
    getCountriesAndLanguages$ = createEffect(() =>
        this.action$
            .pipe(
                ofType<GetCountriesAndLanguages>(ActionTypes.GetCountriesAndLanguages),
                withLatestFrom(this.store.select(state => state.countriesAndLanguages)),
                mergeMap(([action, state]) => {
                    if (Object.keys(state).length === 0 || action.payload && action.payload.reload) {
                        return this.requestUtil.request(this.userManagementService.getCountriesAndLanguages().pipe(
                            map(result => ({type: ActionTypes.GetCountriesAndLanguagesComplete, payload: result}))
                        ));
                    }
                    return of(state).pipe(
                        map(result => ({type: ActionTypes.GetCountriesAndLanguagesComplete, payload: result}))
                    );
                })
            )
    );
    constructor(
        private action$: Actions,
        private store: Store<UserManagementState>,
        private userManagementService: UserManagementService,
        private requestUtil: RequestUtil
    ) {}


}

